import React from 'react'

import { Box, Typography } from "@mui/material"


export default function officeNameColumn() {

	return {
		name: 'name',
		label: 'Office',
		options: {
			setCellHeaderProps: () => ({
				sx: {
					position: 'sticky',
					top: 0,
					left: 0,
					zIndex: '150 !important',
				}
			}),
			setCellProps: (_, idx) => ({
				sx: {
					position: 'sticky',
					left: 0,
					zIndex: 3,
					minWidth: 160,
					backgroundColor: idx % 2 === 0 ? 'background.grey' : 'background.lightGrey',
				}
			}),
			customBodyRowRenderLite: officeName => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
				<Typography sx={{ fontWeight: "bold" }}>{officeName}</Typography>
			</Box>,
		}
	}
}